var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#FFF2F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.46 47.9999H46.54C48.5933 47.9999 49.8733 45.7732 48.8467 43.9999L38.8067 26.6532C37.78 24.8799 35.22 24.8799 34.1933 26.6532L24.1533 43.9999C23.1267 45.7732 24.4067 47.9999 26.46 47.9999ZM36.5 38.6666C35.7667 38.6666 35.1667 38.0666 35.1667 37.3332V34.6666C35.1667 33.9332 35.7667 33.3332 36.5 33.3332C37.2333 33.3332 37.8333 33.9332 37.8333 34.6666V37.3332C37.8333 38.0666 37.2333 38.6666 36.5 38.6666ZM37.8333 43.9999H35.1667V41.3332H37.8333V43.9999Z",
    fill: "#EC002A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/IconError.0310c74ec577bcd9dc5dc54665411437.svg";
export { ForwardRef as ReactComponent };